import { Badge } from '@cocoonspace/ui/components/badge'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'

export const SoonBadge = ({ className }: { className?: string }) => {
	const { t } = useLingui()

	return (
		<Badge
			className={cn('text-xxs px-2', className)}
			variant='outline'
			size='sm'
		>
			{t`Bientôt!`}
		</Badge>
	)
}
